$(function () {
  'use strict';
});
